export default __webpack_public_path__ + "static/media/photo_5282747746622312927_y.3c9a0b30.jpg";